import { addRoute } from "routes";
import { InitialSetupPage } from "./InitialSetupPage";
import { SettingsPage } from "./SettingsPage";
import { TeamSetupPage } from "./TeamSetupPage";
import { BackofficePage } from "./BackofficePage";
import { WorkspacePage } from "./WorkspacePage";
import { ToolsPage } from "./ToolsPage";
import { SpecialistsPage } from "./SpecialistsPage";
import { ActivityLogPage } from "./TasksPage";
import { ScheduledTasksPage } from "./ScheduledTasksPage";
import { KnowledgeBasePage } from "./KnowledgeBasePage";
import { NotificationsPage } from "./NotificationsPage";

// Rotas estáticas / específicas devem ser registradas ANTES do splat global (`/*` do WorkspacePage),
// para que o ranking do <Routes> não as ofusque em casos de hot reload / mudança de userStatus.
addRoute("/tasks", ActivityLogPage, { requiresAuth: true });
addRoute("/scheduled-tasks", ScheduledTasksPage, { requiresAuth: true });
addRoute("/knowledge-base", KnowledgeBasePage, { requiresAuth: true });
addRoute("/team-setup", TeamSetupPage, { requiresAuth: true, minimumPermission: 2 });
addRoute("/notifications", NotificationsPage, { requiresAuth: true });
addRoute("/notifications/:notificationId", NotificationsPage, { requiresAuth: true });
addRoute("/tools/*", ToolsPage, { requiresAuth: true });
addRoute("/specialists", SpecialistsPage, { requiresAuth: true });
addRoute("/settings/*", SettingsPage, { requiresAuth: true });
addRoute("/backoffice/*", BackofficePage, { requiresAuth: true, minimumPermission: 1 });
addRoute("/*", WorkspacePage, { requiresAuth: true });
